module.exports = {
  extend: {
    colors: {
      primary: {
        100: '#9EAFCD',
        200: '#8596B4',
        300: '#6B7C9A',
        400: '#526381',
        50: '#D1E2FF',
        500: '#384967',
        600: '#2B3C5A',
        700: '#1F304E',
        800: '#122341',
      },
      secondary: {
        100: '#33FAE4',
        200: '#26EDD7',
        300: '#1AE1CB',
        400: '#0DD4BE',
        50: '#CCFFFF',
        500: '#00C7B1',
        600: '#00BAA4',
        700: '#00AE98',
        800: '#00A18B',
      },
      tertiary: {
        100: '#FFB6E2',
        200: '#FF9DC9',
        300: '#FF83AF',
        400: '#FF6A96',
        50: '#FFE9FF',
        500: '#FE507C',
        600: '#F1436F',
        700: '#E53763',
        800: '#D82A56',
      },
    },
  },
};
